import React, { useContext } from 'react'
import styled from 'styled-components'
import { borderRadiusSizes } from '@jarvis.oddle/core/theme/default'
import Card from '@jarvis.oddle/core/components/Card'
import { Text } from '@jarvis.oddle/core/components/Typo'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import breakpoint from 'src/utils/styledComponentsBreakpoint'

const StyledCard = styled(Card).attrs(() => ({
  borderRadius: borderRadiusSizes.small
}))`
  width: 100%;
  padding: 0;
  margin: 0;
  position: sticky;
  z-index:1;
  top: 61px;
  ${breakpoint('desktop')`
    display: none;
  `}
`

const TabContainer = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`

const Tab = styled.li<{ active?: boolean }>`
  width: 50%;
  list-style: none;
  text-align: center;
  transition: all 0.7s;
  padding: 20px 0;
  ${(props) =>
    props.active
      ? `
    border-bottom: 2px solid ${props.theme.buttonColor};
  `
      : `
  background-color: rgba(0, 0, 0, 0.05)
  `}
`

const StyledTextHeading = styled(Text)<{ active: boolean }>`
  font-weight: ${props => props.active ? 700 : 500 };
  color: ${props => props.theme.colorHeadingsFont};
`

interface TabOrderProps {
  tabActive: string
  setTabActive: (tabActive: TabType) => void
}

type TabType = 'TRACK ORDER' | 'VIEW ORDER'

const MobileTabOrder = ({
  tabActive,
  setTabActive
}: TabOrderProps): JSX.Element => {
  const { t } = useContext(TranslationContext)
  return (
    <StyledCard>
      <TabContainer>
        <Tab
          active={tabActive === 'TRACK ORDER'}
          onClick={() => setTabActive('TRACK ORDER')}
          data-testid='trackOrderTab'
        >
          <StyledTextHeading active={tabActive === 'TRACK ORDER'}>
            {t('TRACK ORDER')}
          </StyledTextHeading>
        </Tab>
        <Tab
          data-testid='viewOrderTab'
          active={tabActive === 'VIEW ORDER'}
          onClick={() => setTabActive('VIEW ORDER')}
        >
          <StyledTextHeading active={tabActive === 'VIEW ORDER'}>
            {t('VIEW ORDER')}
          </StyledTextHeading>
        </Tab>
      </TabContainer>
    </StyledCard>
  )
}

export default MobileTabOrder
